import React, { useState } from 'react';
import css from '../calculatorStyles.module.css';
import { calculateAAD } from '../engine/aadEngine';
import { MANUFACTURERS } from '../config/aadConfig';
import ResultDisplay from './ResultDisplay';
import { formatLabel } from '../calculatorUtils';

const AADCalculator = () => {
  const [customPrice, setCustomPrice] = useState(false);
  const [manufacturer, setManufacturer] = useState('');
  const [model, setModel] = useState('');
  const [newPrice, setNewPrice] = useState('');
  const [domYear, setDomYear] = useState('');
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);

  const mfrOptions = Object.keys(MANUFACTURERS).sort();
  const modelOptions = manufacturer
    ? Object.keys(MANUFACTURERS[manufacturer]?.models || {}).sort()
    : [];

  const handleManufacturerChange = e => {
    setManufacturer(e.target.value);
    setModel('');
    setResults(null);
  };

  const handleCalculate = () => {
    setError(null);
    try {
      if (!domYear) {
        throw new Error('Please enter a DOM year.');
      }
      const params = {
        domYear: parseInt(domYear, 10),
      };
      if (!manufacturer) {
        throw new Error('Please select a manufacturer.');
      }
      params.manufacturer = manufacturer;
      if (customPrice) {
        if (!newPrice) {
          throw new Error('Please enter the new price.');
        }
        params.customNewPriceEur = parseFloat(newPrice);
      } else {
        if (!model) {
          throw new Error('Please select a model.');
        }
        params.model = model;
      }
      const result = calculateAAD(params);
      setResults(result);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleReset = () => {
    setCustomPrice(false);
    setManufacturer('');
    setModel('');
    setNewPrice('');
    setDomYear('');
    setResults(null);
    setError(null);
  };

  return (
    <div className={css.calculator}>
      <div className={css.card}>
        <label className={css.checkboxLabel}>
          <input
            type="checkbox"
            checked={customPrice}
            onChange={e => { setCustomPrice(e.target.checked); setResults(null); }}
          />
          My model is not listed
        </label>
        <div className={css.grid}>
          <div className={css.field}>
            <label className={css.label}>Manufacturer</label>
            <select
              className={css.select}
              value={manufacturer}
              onChange={handleManufacturerChange}
            >
              <option value="">Select...</option>
              {mfrOptions.map(m => (
                <option key={m} value={m}>{formatLabel(m)}</option>
              ))}
            </select>
          </div>
          {customPrice ? (
            <div className={css.field}>
              <label className={css.label}>New Price (EUR)</label>
              <input
                type="number"
                className={css.input}
                value={newPrice}
                onChange={e => setNewPrice(e.target.value)}
                placeholder="e.g. 1330"
              />
            </div>
          ) : (
            <div className={css.field}>
              <label className={css.label}>Model</label>
              <select
                className={css.select}
                value={model}
                onChange={e => { setModel(e.target.value); setResults(null); }}
                disabled={!manufacturer}
              >
                <option value="">Select...</option>
                {modelOptions.map(m => (
                  <option key={m} value={m}>{formatLabel(m)}</option>
                ))}
              </select>
            </div>
          )}
          <div className={css.field}>
            <label className={css.label}>DOM Year</label>
            <input
              type="number"
              className={css.input}
              value={domYear}
              onChange={e => setDomYear(e.target.value)}
              placeholder="e.g. 2020"
            />
          </div>
        </div>
        <div className={css.actions}>
          <button type="button" className={css.btnPrimary} onClick={handleCalculate}>
            Calculate
          </button>
          <button type="button" className={css.btnSecondary} onClick={handleReset}>
            Reset
          </button>
        </div>
      </div>
      {error && (
        <div className={`${css.error} ${css.errorVisible}`} role="alert">
          <strong>Error</strong>
          {error}
        </div>
      )}
      {results && <ResultDisplay {...results} />}
    </div>
  );
};

export default AADCalculator;
